import { useTranslate } from "@similarweb/i18n-provider";
import { ErrorBox } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import {
    ONBOARDING_AGENT_ERROR_DESCRIPTION,
    ONBOARDING_AGENT_ERROR_RETRY,
    ONBOARDING_AGENT_ERROR_TITLE,
} from "../texts";

import { ErrorBannerButton, ErrorContent, ErrorIconWrap } from "./styles";

export type OnboardingAgentChatErrorProps = {
    onRetry: () => void;
};

export const OnboardingAgentChatError = ({ onRetry }: OnboardingAgentChatErrorProps) => {
    const { translate } = useTranslate();

    return (
        <ErrorBannerButton
            onClick={onRetry}
            data-automation="onboarding-agent-chat-error"
            aria-label={translate(ONBOARDING_AGENT_ERROR_RETRY)}
        >
            <ErrorIconWrap aria-hidden>
                <ErrorBox
                    size="xs"
                    color={colorsPalettes.red[400]}
                />
            </ErrorIconWrap>
            <ErrorContent>
                <Text
                    as="span"
                    fontVariant="report"
                    color={colorsPalettes.red[400]}
                >
                    {translate(ONBOARDING_AGENT_ERROR_TITLE)}
                </Text>
                <Text
                    as="span"
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate(ONBOARDING_AGENT_ERROR_DESCRIPTION)}
                </Text>
            </ErrorContent>
        </ErrorBannerButton>
    );
};
